module.exports = __webpack_public_path__ + "img/bg2.52da4615.png";